import React, {Component, Fragment} from 'react';
import axios from 'axios';
import Ratings from 'react-ratings-declarative';

class RatingForm extends Component {

    constructor(props) {
        super(props);
        document.title = 'Rating form';
    }

    state = {
        userDetails: JSON.parse(localStorage.getItem("user")),
        formData: {
            rating: {
                value: 0,
                isValid: true,
                message: ''
            },
            ratingText: {
                value: '',
                isValid: true,
                message: ''
            },
        },
        hotel: {
            id: null,
            hotelName: ""

        }

    };

    placeholder = {
        rating: "1-10",
        ratingText: "Rating",

    };

    componentDidMount() {
        axios.get("/api/ratings/ratingform/" + this.props.match.params.id)
            .then(response => {

                this.setState({
                    hotel: {
                        id: response.data.hotelId,
                        hotelName: response.data.hotelName
                    }
                })
            })
            .catch(error => {
                console.log(error);
            })


    }

    changeRatings= newRating => {
        const rating = newRating*2
        this.setState({
            formData: {
                rating: {
                    value: rating,
                    isValid: true,
                    message: ''
                }
            }

        });
    }


    inputChangeHandler = event => {
        const value = event.target.value;
        const fieldName = event.target.name;
        const updatedFormData = {...this.state.formData};

        updatedFormData[fieldName] = {
            value: value,
            isValid: true,
            message: null
        }

        this.setState({formData: updatedFormData})
    };

    validationHandler = error => {
        const responseData = error.response.data;
        const updatedFormData = {...this.state.formData};
        if (responseData !== null) {
            if (responseData.globalError) {
                this.setState({globalMessage: responseData.globalError});
            }
            if (responseData.fieldErrors) {
                for (let fe of responseData.fieldErrors) {
                    updatedFormData[fe.field] = {
                        value: this.state.formData[fe.field].value,
                        isValid: false,
                        message: fe.message
                    }
                }
            }
            this.setState({formData: updatedFormData});
        } else {
            this.setState({globalMessage: error});
        }
    };




    formSubmit = event => {
        event.preventDefault();
        const data = {
            rating: parseInt(this.state.formData.rating.value),
            ratingText: this.state.formData.ratingText.value,
            hotelId: this.state.hotel.id,
            userId: this.state.userDetails.id
        };

        axios.post("/api/ratings/" + this.props.match.params.id, data)
            .then(() => {
                this.props.history.push("/ratings/" + this.props.match.params.id);
            })
            .catch(error => {
                console.warn("error.response: ", error === null ? error.response : error);
                console.log("error.response.data: ", error === null ? error : error);
                this.validationHandler(error);
            });
    }


    render() {

        const bgStyle = {
            height: "30vh",
            backgroundImage: "url('../assets/img/city-profile.jpg')",
            marginTop: "-20px",
            backgroundPosition: "top center"

        };

        return (


            <Fragment>
                <div className="page-header header-filter align-content-lg-center" data-parallax="true"
                     style={bgStyle}>
                    <div className="container">
                        <h1 className="card-title text-light">New rating</h1>
                        <br/>
                        <br/>
                        <br/>

                    </div>
                </div>
                <div className="main main-raised">
                    <div className="profile-content">
                        <div className="container">
                            <br/>
                            <form onSubmit={this.formSubmit}>

                                <Ratings
                                    rating={this.state.formData.rating.value/2}
                                    widgetRatedColors="blue"
                                    changeRating={this.changeRatings}
                                >
                                    <Ratings.Widget widgetHoverColor="orange" />
                                    <Ratings.Widget widgetHoverColor="orange" />
                                    <Ratings.Widget widgetHoverColor="orange" />
                                    <Ratings.Widget widgetHoverColor="orange" />
                                    <Ratings.Widget widgetHoverColor="orange" />
                                </Ratings>

                                        <div>
                                            <label>Rating</label>
                                            <input
                                                className="form-control"
                                                name="ratingText"
                                                type="text"
                                                onChange={this.inputChangeHandler}
                                                placeholder="Write your rating here"
                                            /></div>


                                    <br/>
                                    <button className="btn btn-primary my-buttons" type="submit">Send rating</button>
                            </form>

                        </div>
                    </div>
                </div>
            </Fragment>

        )
    }
}

export default RatingForm;


// WEBPACK FOOTER //
// ./src/containers/RatingForm/RatingForm.jsx